import { MSDropdown } from '../../common/dropdown/index.js';
import { makeid } from '../../common/utils/idgen.js';
import styles from './intervals.css'

const DropdownValues = () => [
    { id: makeid(10), component: i18next.t("chartintervals_last_year"), value: 0, active: true },
    { id: makeid(10), component: i18next.t("chartintervals_last_six_months"), value: 1, active: true },
    { id: makeid(10), component: i18next.t("chartintervals_current_month"), value: 2, active: true },
    { id: makeid(10), component: i18next.t("chartintervals_last_week"), value: 3, active: true },
];

const template = () => `
    <style>
        ${styles}
    </style>
    <ui-dropdown value="" id="nav-interval">
        <div slot="label" id="interval-dropdown-label" class="interval-dropdown-label">
            <div id="dropdown-inner">${i18next.t("chartcolumn_your_interval")}</div>
            <div class="icon-arrow"></div>
        </div>
    </ui-dropdown>
`;

/**
 * @class ChartIntervals
 * @classdesc Интервалы столбчатой диаграммы
 * */
export class ChartIntervals {

    constructor(container, root) {
        this.container = container
        this.root = root
        this.state = this.root.state
        this.container.innerHTML = template()
        this.root.checkComponent('ui-dropdown', MSDropdown)
        this.labelElem = this.container.querySelector('#dropdown-inner')
        this.initDropdown()
    }

    initDropdown() {
        this.dropdown = this.root.shadowRoot.querySelector('#nav-interval')
        this.dropdown.values = DropdownValues();
        this.dropdown.cssElem.innerHTML += styles
        this.dropdown.onOpenHandler = this.dropdown.onCloseHandler = this.onToggleDropdown.bind(this)
        this.dropdown.onClick = this.root.changeIntervalHandler.bind(this.root)
        this.dropdown.createList()
        this.root.shadowRoot.addEventListener('click', this.autoClose.bind(this))
    }

    autoClose(e) {
        if (!this.dropdown?.active) return
        const target = e.target
        if (!target.shadowRoot && !this.dropdown.contains(target)) this.dropdown.active = false
    }

    onToggleDropdown() {
        if (this.dropdown.active) {
            this.dropdown.rootElem.style.marginTop = -5
            this.dropdown.rootElem.style.marginRight = -5
        } else {
            this.dropdown.rootElem.style.marginTop = 0
            this.dropdown.rootElem.style.marginRight = 0
        }
    }

    get value() {
        return this.state.intervalId
    }
    set value(v) {
        this.state.intervalId = v;
        if (!this.labelElem) return
        const item = this.dropdown.values.find(item => item.id === v)
        if (!item) return
        this.labelElem.innerHTML = item.component
    }
}